define([
    "dojo/_base/declare",
    "dojo/_base/lang",
    "csi/html/ViewRef",
    "csi/html/Widget",
    "csi/reflection",
    "csi/xml",
    "./SelectSetHelper"
], function(declare,lang,ViewRef,Widget,reflection,xml,SelectSetHelper) {

    return declare(Widget, {
            _resolveView: function() {
                //set the target for relationship to the class of the type
                var view = this.defView;

                var type = SelectSetHelper.getSubtypeName(this.getViewNode());
                var viewRef2 = lang.mixin(new ViewRef(), {
                    bFixedKey:true,
                    key: 2,
                    m_id: SelectSetHelper.SELECT_SET_TYPE_ITEMS_VIEW_DEF[type]
                });

                view.addResource(2,true,viewRef2);

                this.inherited(arguments);
            }
    });
});